import { motion } from 'framer-motion';

const AnimatedWrapper = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -50 }}
      transition={{ duration: 0.3 }}
      style={{ height: 'calc(var(--vh, 1vh) * 100)' }}  // здесь важно
      className="w-full flex justify-center items-center"
    >
      <div className="w-full max-w-[450px] h-full px-4 pt-1 bg-white rounded-lg shadow-md overflow-hidden border flex flex-col">
        {children}
      </div>
    </motion.div>
  );
};

export default AnimatedWrapper;